import {IntermediatePart} from "../../intermediatePart";
import {getCurrentRoomType} from "../../../../appLayout";
import {LOOK_ROOM_TYPES, VANITY_TYPES} from "../../constants";

export default class VanityCommon extends IntermediatePart {

  constructor(props) {
    super(props);
  }

  getArrayOfConditions() {
    const vanityParent = this.getParent();
    let conditions = super.getArrayOfConditions(); //roomLayout
    let vanitySize = vanityParent.counterTopSize(this);
    if (this.partId === "vanity_mirror") {
      const currentVanityTypeFeatureGroup = vanityParent.relatedItems.find(relItem => relItem.partId === vanityParent.vanity_type);
      if (currentVanityTypeFeatureGroup && currentVanityTypeFeatureGroup.layerPositions) {
        if (vanitySize === "24" || (Array.isArray(vanitySize) && vanitySize.includes("24"))) {
          if (currentVanityTypeFeatureGroup.layerPositions["L"] && currentVanityTypeFeatureGroup.layerPositions["R"]) {
            conditions.push({
              propName: "MirrorShape",
              propValue: "24D"
            });
          } else if (currentVanityTypeFeatureGroup.layerPositions["C"]) {
            conditions.push({
              propName: "MirrorShape",
              propValue: "24S"
            });
          }
        }
      }
    }
    if (this.partId === "vanity_backsplash") {
      const activeSideMeta = vanityParent.getActiveMatchingMetaFromRelatedItem(vanityParent.vanity_type, "Side");
      if (activeSideMeta && activeSideMeta.includes("C")) {
        conditions.push({
          propName: "Side",
          propValue: activeSideMeta
        });
      }
    }
    if (vanitySize && (getCurrentRoomType() === LOOK_ROOM_TYPES.as)
        && !(this.partId === "vanity_countertop" && vanityParent.vanity_type !== VANITY_TYPES.vanity_cabinet)) {
      conditions.push({
        propName: "VanitySize",
        propValue: vanitySize
      })
    }
    return conditions
  }

}
